<template>
  <nav class="navbar navbar-expand-lg px-4 ef-navbar">
    <router-link class="navbar-brand d-flex align-items-center gap-2" to="/">
      <span class="brand-icon">🅿</span>
      <span class="brand-text">{{ appTitle }}</span>
    </router-link>

    <button
      class="navbar-toggler ef-navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navMenu"
      aria-controls="navMenu"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navMenu">
      <ul class="navbar-nav ms-auto align-items-center gap-1">
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/" @click="closeMenu">홈</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/notices" @click="closeMenu">공지사항</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/parking-area-info" @click="closeMenu">주차장 정보</router-link>
        </li>
        <li v-if="isLoggedIn" class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/parking-pass-waiting-reg" @click="closeMenu">정기권 신청</router-link>
        </li>
        <li v-if="isLoggedIn && isVisibleTicketResult" class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/ticket-result-personal" @click="closeMenu">추첨 결과</router-link>
        </li>
        <li v-if="isLoggedIn" class="nav-item">
          <router-link class="nav-link ef-nav-link" to="/user-info-edit" @click="closeMenu">정보 수정</router-link>
        </li>
        <li v-if="!isLoggedIn" class="nav-item">
          <router-link class="ef-login-btn" to="/login" @click="closeMenu">로그인</router-link>
        </li>
        <li v-if="isLoggedIn" class="nav-item">
          <button class="ef-logout-btn" @click="logoutAndClose">로그아웃</button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NavBar',
  data() {
    return {
      isLoggedIn: false,
      isVisibleTicketResult: null,
      appTitle: process.env.VUE_APP_TITLE || 'EF Park'
    }
  },
  mounted() {
    this.checkLoginStatus()
    // bind the handler so `this` is preserved when called from window event
    this._onUserAuthChanged = this.checkLoginStatus.bind(this)
    window.addEventListener('user-auth-changed', this._onUserAuthChanged)
    // Also watch route changes to refresh auth state
    this.$watch(() => this.$route.path, () => this.checkLoginStatus())
  },
  beforeUnmount() {
    if (this._onUserAuthChanged) window.removeEventListener('user-auth-changed', this._onUserAuthChanged)
  },
  methods: {
    checkLoginStatus() {
      const user = sessionStorage.getItem('user')
      this.isLoggedIn = !!user
      // 로그인되어 있으면 CommonConfig 한 번만 로드
      if (this.isLoggedIn) {
        if (!this._commonConfigLoaded) {
          this.fetchCommonConfig()
        }
      } else {
        this._commonConfigLoaded = false
      }
    },
    async fetchCommonConfig() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/common-config`)
        if (res.data.success && res.data.config) {
          this.isVisibleTicketResult = res.data.config.IsVisibleTicketResult
          this._commonConfigLoaded = true
        }
      } catch (e) {
        console.error('Common config fetch error:', e)
        // 오류 시에도 로드 표시를 해서 계속 요청하지 않음
        this._commonConfigLoaded = true
      }
    },
    closeMenu() {
      const navMenu = document.getElementById('navMenu')
      if (navMenu) {
        navMenu.classList.remove('show')
      }
    },
    logout() {
      sessionStorage.removeItem('user')
      this._commonConfigLoaded = false
      try { window.dispatchEvent(new Event('user-auth-changed')) } catch (e) { /* ignore */ }
      this.isLoggedIn = false
      this.$router.push('/')
    },
    logoutAndClose() {
      this.logout()
      this.closeMenu()
    }
  }
}
</script>

<style scoped>
.ef-navbar {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
  min-height: 62px;
}

.navbar-brand {
  text-decoration: none;
}

.brand-icon {
  font-size: 1.5rem;
  line-height: 1;
  color: #ffffff;
}

.brand-text {
  font-size: 1.3rem;
  font-weight: 700;
  color: #e0e0e0;
  letter-spacing: 1px;
}

.ef-navbar-toggler {
  border: 2px solid #ffffff !important;
  padding: 0.45rem 0.65rem;
  transition: all 0.3s ease;
}

.ef-navbar-toggler:focus {
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.25);
}

.ef-navbar-toggler:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: #ffffff;
}

.ef-navbar-toggler .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23ffffff' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2.5' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  width: 1.5rem;
  height: 1.5rem;
}

.ef-nav-link {
  color: #b0bec5 !important;
  font-weight: 500;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
  text-decoration: none;
}

.ef-nav-link:hover,
.ef-nav-link.router-link-active {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.1);
}

.ef-login-btn {
  color: #1a1a2e !important;
  background: #e0e0e0;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  border-radius: 20px;
  text-decoration: none;
  transition: background 0.2s, transform 0.1s;
  font-size: 0.9rem;
}

.ef-login-btn:hover {
  background: #ffffff;
  transform: translateY(-1px);
}

.ef-login-btn.router-link-active {
  background: #ffffff;
}

.ef-logout-btn {
  color: #1a1a2e !important;
  background: #e0e0e0;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  font-size: 0.9rem;
}

.ef-logout-btn:hover {
  background: #ffffff;
  transform: translateY(-1px);
}

.ef-admin-btn {
  color: #ffb3b3 !important;
  border: 1px solid rgba(230, 57, 70, 0.5);
  font-weight: 600;
  padding: 0.35rem 1rem;
  border-radius: 20px;
  text-decoration: none;
  transition: background 0.2s, border-color 0.2s, transform 0.1s;
  font-size: 0.85rem;
}

.ef-admin-btn:hover {
  background: rgba(230, 57, 70, 0.2);
  border-color: #e63946;
  color: #fff !important;
  transform: translateY(-1px);
}
</style>
